(function () {
  'use strict';

  var ANIMATED_CLASS = 'evolve-animate--visible';
  var SELECTOR = '[data-evolve-animate]';

  function init() {
    /* In Shopify design mode, show everything immediately */
    if (window.Shopify && window.Shopify.designMode) {
      var els = document.querySelectorAll(SELECTOR);
      for (var i = 0; i < els.length; i++) {
        els[i].classList.add(ANIMATED_CLASS);
      }
      return;
    }

    /* Respect prefers-reduced-motion */
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add(ANIMATED_CLASS);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15
    });

    var elements = document.querySelectorAll(SELECTOR);
    elements.forEach(function (el) {
      /* Apply delay custom property from data attribute */
      var delay = el.getAttribute('data-evolve-delay');
      if (delay) {
        el.style.setProperty('--animate-delay', delay + 'ms');
      }
      observer.observe(el);
    });
  }

  /* Run on DOMContentLoaded or immediately if already loaded */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init when Shopify sections are loaded/reordered in the editor */
  document.addEventListener('shopify:section:load', init);
})();
